import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommitteeDto, initializedCommitteeDto } from '../shared/dto/committee.dto';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { SelectItem } from 'primeng/api';
import { NgForm } from '@angular/forms';
import { CommitteeService } from '../shared/committee.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-committee-add-dialog',
  templateUrl: './committee-add-dialog.component.html',
  styleUrls: ['./committee-add-dialog.component.less'],
  standalone: false,
})
export class CommitteeAddDialogComponent implements OnInit {
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    this.showChange.emit(this._show);
  }
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('addForm') addForm: NgForm;

  isSaving = false;
  committee: CommitteeDto = initializedCommitteeDto();
  affCodeItems: SelectItem[] = [];
  private _show: boolean;
  constructor(
    private _affCodeService: AffCodeService,
    private _committeeService: CommitteeService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this._affCodeService.getAllAffCodes().then((affCodes) => {
      this.affCodeItems = affCodes.map<SelectItem>((x) => {
        return { label: x.AffCode, value: x.AffCode };
      });
    });
  }

  public open() {
    this.committee = initializedCommitteeDto();
    this.show = true;
  }

  save() {
    this.isSaving = true;
    this._committeeService
      .create(this.committee)
      .then((newId) => {
        this._navigationService.navigateToCommitteeEdit(newId);
        this.close();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  close() {
    this.addForm?.form.markAsPristine();
    this.show = false;
  }
}
